import { DeviceService } from '@/app/devices/services/device.service'
import { deviceModel } from '@/app/devices/model/device.model'
import { getOwners, getDrivers,getSubstitute, getGroups, getContracts, getCategoriesBy, getTypesByCategory } from '@/app/share/lists'

const initialState = () => {

  return {
    loading: false,
    errors: null,
    requestsCount: 0,

    typesOptions: [],
    ownersOptions: [],
    groupsOptions: [],
    contractsOptions: [],
    categoriesOptions: [],
    driversOptions: [],
    substituteOptions:[],

    data: Object.assign({}, deviceModel)
  }
}

const mutations = {
  /** reinit state */
  INIT_STATE(state) {
    const model = Object.assign({}, deviceModel)

    Object.assign(state, {
      loading: false,
      errors: null,
      data: {
        ...model,
        attributes: [],
        camera_attributes: [],
        scaleSensorsSetting: []
      },
    });
  },

  /** device data request */
  DEVICE_DATA_REQUEST(state) {
    Object.assign(state, { loading: true, errors: null });
  },

  /** device data success */
  DEVICE_DATA_SUCCESS(state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },

  /** device data error */
  DEVICE_DATA_ERROR(state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      errors: payload || true
    });
  },

  /** owners data  */
  SET_OWNERS(state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      ownersOptions: payload
    });
  },

  SET_DRIVERS(state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      driversOptions: payload
    });
  },

  SET_SUBSTITUTES(state,payload){
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      substituteOptions: payload
    });
  },


  /** types data  */
  SET_TYPES(state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      typesOptions: payload
    });
  },

  /** groups data  */
  SET_GROUPS(state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      groupsOptions: payload
    });
  },

  /** categories data  */
  SET_CATEGORIES(state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      categoriesOptions: payload,
      requestsCount: requests_count
    });
  },

  /** contracts data  */
  SET_CONTRACTS(state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      contractsOptions: payload,
      requestsCount: requests_count
    });
  },

  /** reset device data */
  DEVICE_DATA_RESET(state) {
    Object.assign(state, ...initialState);
  },

  /** device data */
  SET_DEVICE_DATA(state, payload) {
    Object.assign(state, { data: payload });
  },

  /** reset device data */
  SET_REQUESTS_COUNT(state, count) {
    Object.assign(state, {
      requestsCount: count
    });
  },


  /**   */
  SET_ATTRIBUTES(state, attrs) {
    Object.assign(state.data, {
      attributes: attrs
    });
  },

  SET_CAMERA_ATTRIBUTES(state, attrs) {
    Object.assign(state.data, {
      camera_attributes: attrs
    });
  },



  /**   */
  SET_SENSORS_ATTRS(state, attrs) {
    Object.assign(state.data, {
      scaleSensorsSetting: attrs
    });
  },
  SET_VALIDATION_ERRORS(state, errors) {
    state.errors = errors;
    state.loading = false;
  },
  SET_WASAL_DELTED(state){

   state.data.sequenceNumber="";
   state.data.imeiNumber="";
   state.data.plateType=null;
   state.data.wasl=false;
  },
  SET_LOADING(state, payload){
    state.loading = payload
  },
  SET_ASSIGN_TO_MASADER(state, payload){
    state.data.assign_to_masader = payload.value
  }

};




const actions = {

  /** fetch device data */
  async fetchDeviceData(context, id) {
    context.commit('DEVICE_DATA_REQUEST');
    const result = await DeviceService.getDeviceById(id).catch(e => {
      context.commit('DEVICE_DATA_ERROR', e);
    });

    if (result) {
      context.commit('DEVICE_DATA_SUCCESS', result);
      await context.dispatch('prepareAttributes')
      await context.dispatch('prepareCameraAttributes')
      await context.dispatch('prepareScale')
      await context.dispatch('fetchTypesByCategory', context.state.data.category)
    }

    return result;
  },

  async refilterContractsByOwner(context, params) {
    const contracts = await getContracts(params)
    context.commit('SET_CONTRACTS', contracts.data.data)

  },


  /** fetch all lists */
  async fetchLists(context, authId) {

    context.commit('SET_REQUESTS_COUNT', 4)

    const groups = await getGroups({ user: authId })
    context.commit('SET_GROUPS', groups.data.data)

    const contracts = await getContracts({ user: authId })
    context.commit('SET_CONTRACTS', contracts.data.data)

    const owners = await getOwners({ user: authId })
    context.commit('SET_OWNERS', owners.data.data)


    const drivers = await getDrivers({ user: authId, isWasl: true })
    context.commit('SET_DRIVERS', drivers.data.data)

    const substitutes=await getSubstitute({user:authId,isSubstitute:true,cols:'id,name,category'})
    context.commit('SET_SUBSTITUTES',substitutes.data.data)



    getCategoriesBy({ type: 'device' }).then(categories => {
      context.commit('SET_CATEGORIES', categories.data.data)
    })

  },


  async fetchTypesByCategory(context, cat) {
    const types = await getTypesByCategory({ category: cat })
    context.commit('SET_TYPES', types.data.data)
  },


  prepareAttributes(context) {
    const attr = context.state.data.attributes
    context.state.data.attributes = []

    let x = 0
    for (const i in attr) {
      context.state.data.attributes.push({
        id: x++,
        key: i,
        value: attr[i]
      })
    }
  },

  prepareCameraAttributes(context) {
    const attr = context.state.data.camera_attributes
    context.state.data.camera_attributes = []

    let x = 0
    for (const i in attr) {
      context.state.data.camera_attributes.push({
        id: x++,
        key: i,
        value: attr[i]
      })
    }
  },


  prepareScale(context) {
    const attr = context.state.data.scaleSensorsSetting
    context.state.data.scaleSensorsSetting = []

    let x = 0
    for (const i in attr) {
      context.state.data.scaleSensorsSetting.push({
        id: x++,
        key: i,
        value: attr[i]
      })
    }
  },



  clearForm(ctx) {
    ctx.commit('INIT_STATE')
  },


  updateAttributes(ctx, attrs) {
    ctx.commit('SET_ATTRIBUTES', attrs)
  },

  updateCameraAttributes(ctx, attrs) {
    ctx.commit('SET_CAMERA_ATTRIBUTES', attrs)
  },



  updateScaleSensors(ctx, attrs) {
    ctx.commit('SET_SENSORS_ATTRS', attrs)
  },


  async createDevice(context) {
    return new Promise((resolve, reject) => {
      context.commit('DEVICE_DATA_REQUEST')
      const deviceData = context.state.data
      DeviceService.createDevice(deviceData).then(res => {
        context.commit('DEVICE_DATA_REQUEST')
        context.commit('INIT_STATE')
        resolve(res)
      }).catch(reason => {
        context.state.loading = false
        if (reason.status === 422) {
          context.state.errors = reason.data.errors
        }
      })
    })
  },


  async saveData(context) {

    return new Promise((resolve, reject) => {
      context.commit('DEVICE_DATA_REQUEST')
      const deviceData = context.state.data
      DeviceService.updateDevice(deviceData.id, deviceData).then(res => {
        context.state.loading = false
        resolve(res)
      }).catch(reason => {

        reject(reason)
        context.state.loading = false
        if (reason.status === 422) {
          context.state.errors = reason.data.errors
        }
      })
    })
  },



  async deleteDevice(context, id) {
    return new Promise((resolve, reject) => {
      DeviceService.deleteDevice(id).then(res => {
        resolve(res.data)
      })
    })
  },


  
  async saveWaslData(context, data) {

    return new Promise((resolve, reject) => {
      context.commit('DEVICE_DATA_REQUEST');
    
      DeviceService.vehicleRegister(data).then(res => {
        context.state.loading = false
        context.state.data.wasl = true
        resolve(res)
        if(data.type=="vehicleDelete"){ context.commit("SET_WASAL_DELTED")}
      }).catch(reason => {
        reject(reason)
        if (reason.status == 422 || reason.status == 400) {
           context.state.errors = reason.data
           context.commit("SET_VALIDATION_ERRORS", reason.data)
        }

      }).finally(() => context.state.loading = false)
    })
  },
  printMaintenancesQRCode({ getters, commit }){

    commit('SET_LOADING', true)

      fetch(getters.maintenancesQRCode, { method: 'GET', credentials: 'include' } )
      .then((response) => {

        response.blob().then((blob)=> {

          let iframe =  document.createElement('iframe');
          iframe.src = URL.createObjectURL(blob)
          iframe.style.display = 'none';

          iframe.onload = e => {
            iframe.focus();
            iframe.contentWindow.print();
          }
  
          document.body.appendChild(iframe);
  
          commit('SET_LOADING', false)

        })

      })
      .catch(reason => console.log(reason))
  }

};

const getters = {
  device_id(state){
    return state.data.device_id
  },
  maintenancesQRCode(state, getters){
    return `${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/maintenances/deviceQRCode/${getters.device_id}`
  },
  assign_to_masader(state){
    return state.data.assign_to_masader
  },
  errors(state){
    return state.errors ?? []
  }
}


export default {
  namespaced: true,
  state:()=>({...initialState()}),
  mutations,
  actions,
  getters
};
